import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import LoadingSpinner from './common/LoadingSpinner';

const ProtectedRoute = ({ children, requiresActive = true, allowedRoles = null }) => {
  const { isAuthenticated, loading, user, userType } = useAuth();

  if (loading) {
    return <LoadingSpinner fullScreen />;
  }

  if (!isAuthenticated) {
    // Redirect to appropriate login page based on current path
    const loginPaths = {
      admin: '/admin/login',
      merchant: '/merchant/login',
      customer: '/customer/login'
    };
    const loginPath = loginPaths[userType] || '/merchant/login';
    return <Navigate to={loginPath} replace />;
  }

  // Check if user has required role
  if (allowedRoles && !allowedRoles.includes(userType)) {
    // Redirect to appropriate dashboard
    const dashboards = {
      admin: '/admin/dashboard',
      merchant: '/dashboard',
      customer: '/customer/dashboard'
    };
    const dashboard = dashboards[userType] || '/dashboard';
    return <Navigate to={dashboard} replace />;
  }

  // Check subscription status if required (only for merchants, not admin)
  if (requiresActive && userType === 'merchant' && user?.subscription?.status !== 'active') {
    return <Navigate to="/subscription-expired" replace />;
  }

  return children;
};

export default ProtectedRoute;
